// extracted by mini-css-extract-plugin
module.exports = {"icon":"TrustpilotFallback_icon__9P_N7","fallback":"TrustpilotFallback_fallback__aOC_n"};